import { apiClient } from './apiService';
import { USER_BRANCHES } from './endpoints';

export const userBranchService = {
  async getUserBranches(userId: number): Promise<any> {
    const response = await apiClient.get(`${USER_BRANCHES}/${userId}/branches`);
    return response.data;
  },

  async addBranch(
    userId: number,
    branchId: number,
    isPrimary = false
  ): Promise<any> {
    const response = await apiClient.post(
      `${USER_BRANCHES}/${userId}/branches/${branchId}`,
      { isPrimary }
    );
    return response.data;
  },

  async removeBranch(userId: number, branchId: number): Promise<void> {
    await apiClient.delete(`${USER_BRANCHES}/${userId}/branches/${branchId}`);
  },

  async setPrimaryBranch(userId: number, branchId: number): Promise<any> {
    const response = await apiClient.post(
      `${USER_BRANCHES}/${userId}/branches/${branchId}/primary`
    );
    return response.data;
  }
};
